module.exports = __webpack_public_path__ + "img/systemItem.5e56d1f6.png";